var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es249.js.map
